import roundToDecimals from "PFCore/helpers/round_to_decimals";

const getTimeLabel = (minutes: number): string => `${roundToDecimals(minutes / 60)}h`;

type UseAvailabilityLabel = {
  availableMinutes: number;
  nominalWorkingMinutes: number;
};

export const useAvailabilityLabel = ({
  availableMinutes,
  nominalWorkingMinutes
}: UseAvailabilityLabel): string => {
  if (nominalWorkingMinutes === 0 && availableMinutes === 0) {
    return "";
  }
  return getTimeLabel(availableMinutes);
};
